export const FILTER_NAME = 'invoice'
